
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AssetDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Asset"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"fileName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"fileLocation"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"fileSize"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"status"},"arguments":[],"directives":[]}]}}],"loc":{"start":0,"end":86}};
    doc.loc.source = {"body":"fragment AssetDetails on Asset {\n  id\n  fileName\n  fileLocation\n  fileSize\n  status\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

      module.exports = doc;
    



//////////////////
// WEBPACK FOOTER
// ./src/graphql/fragments/AssetDetails.gql
// module id = H2E7
// module chunks = 102